export default __webpack_public_path__ + "static/media/eventos.2f73d8e8.png";